import React from 'react';
import { useNavigate } from 'react-router-dom';

const CheckEmail = () => {
  const navigate = useNavigate();
  return (
    <div className="auth-page min-h-screen flex items-center justify-center bg-secondary-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold text-secondary-900">
            Check your email
          </h2>
          <div className="mt-4 text-center text-secondary-700">
            <p className="mb-4">A verification email has been sent to your email address. Please click the link in the email to verify your account.</p>
            <p className="text-sm bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-yellow-800">
              <strong>Next Step:</strong> After email verification, your account will be reviewed by an administrator for approval. You'll receive a notification once approved.
            </p>
          </div>
          <div className="mt-8 text-center">
            <button
              className="btn-primary"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail; 